import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import HeadingWithBg from "../../Global/Common/HeadingWithBg/HeadingWithBg"
import { graphql, Link, useStaticQuery } from "gatsby"
import { PressSectionStyles } from "./PressSection.styles"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const formatPublishedOn = (raw) => {
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return raw;
  const day = String(d.getDate()).padStart(2, "0");
  return `${day} ${MONTHS[d.getMonth()]}, ${d.getFullYear()}`;
};

const PressSection = () => {
  const data = useStaticQuery(graphql`
    {
      statamic {
        entries(
          collection: "blog_posts"
          sort: ["published_on desc"]
          filter: {
            blog_categories: { contains: "updates" }
            featured: true
          }
        ) {
          data {
            id
            slug
            ... on Statamic_Entry_BlogPosts_BlogPost {
              title
              featured
              published_on
              external_link
            }
          }
        }
      }
    }
  `)
  const featuredMediaPosts = data?.statamic?.entries?.data || [];
  return (
    <PressSectionStyles>
      <Container className="py-5 px-5 px-lg-0">
        <HeadingWithBg text="Press" />
        <Row>
          <Col>
            <h2 className="h1 my-4 my-lg-5 font-weight-bold secondary-blue-2-text heading announcement-header">
              Recent Press Releases
            </h2>
            {featuredMediaPosts.map((featuredMediaPost) => (
              <div key={featuredMediaPost.id} className="my-5">
                <div className="d-flex primary-blue-text my-2 align-items-center flex-wrap">
                  <div>{formatPublishedOn(featuredMediaPost.published_on)} . Company Update</div>
                  {featuredMediaPost.featured ? (
                    <div className="featured-tag mt-3 mt-lg-0 mx-lg-4 px-5 pt-2 pb-1 text-uppercase ">
                      Featured
                    </div>
                  ) : null}
                </div>
                <h2 className="my-4 primary-blue-text">{featuredMediaPost.title}</h2>
                <Link
                  className="read-more secondary-blue-2-text mx-4"
                  to={featuredMediaPost.external_link || `/blog/${featuredMediaPost.slug}/`}
                >
                  Read More
                </Link>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </PressSectionStyles>
  )
}

export default PressSection
